import { contentBase as contentBaseSchema } from './content';
import { metadata } from './helpers';
import { z } from 'zod';

export const aboutUsContentSchema = z.object({
  metadata: metadata,
  data: z.object({
    about: z.string(),
    picture: z.string(),
    attributes: z.array(
      z.object({
        title: z.string(),
        content: z.string(),
      })
    ),
    advantages: z.array(
      z.object({
        title: z.string(),
        subtitle: z.string().optional(),
        content: z.string(),
        icon: z
          .object({
            name: z.string(),
            content: z.string(),
          })
          .optional(),
        picture: z.string().optional(),
      })
    ),
  }),
});

export const contentTypeAboutUsContentSchema = contentBaseSchema.extend({
  content: aboutUsContentSchema,
});
export type ContentTypeAboutUsContentInput = z.infer<typeof contentTypeAboutUsContentSchema>;
